import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { useGetCarrierParams } from 'feature/dispatching/hooks';
import { downloadTemplate } from '../../utils';

const buttonLinkStyles = {
  background: 'none',
  border: 'none',
  color: 'white',
  cursor: 'pointer',
  fontFamily: 'Gothic A1',
  fontSize: '0.850rem',
  letterSpacing: '0.5px',
  textDecoration: 'underline',
};

const DownloadTemplatesTooltip = () => {
  const { carrier } = useGetCarrierParams();
  const [openTooltip, setOpenTooltip] = useState(false);

  return (
    <Tooltip
      open={openTooltip}
      placement="bottom"
      slotProps={{
        popper: {
          sx: {
            '&:hover': { cursor: 'pointer' },
            pl: 5,
            textAlign: 'center',
          },
        },
      }}
      title={
        <Typography
          onClick={e => e.stopPropagation()}
          onMouseLeave={() => setOpenTooltip(false)}
          sx={{
            color: 'surface.white',
            fontSize: '0.850rem',
            px: 1,
            py: 1 / 2,
          }}
        >
          Click on the document to download our
          <button
            onClick={() => downloadTemplate('M27', carrier)}
            style={buttonLinkStyles}
            type="button"
          >
            Method 27
          </button>
          /
          <button
            onClick={() => downloadTemplate('WT', carrier)}
            style={buttonLinkStyles}
            type="button"
          >
            Wet Test
          </button>
          templates to be completed and submitted for review.
        </Typography>
      }
    >
      <InfoRoundedIcon
        onMouseEnter={() => setOpenTooltip(true)}
        sx={{
          '&:hover': { cursor: 'pointer' },
          color: 'graphic.main',
          ml: 1,
        }}
      />
    </Tooltip>
  );
};

export default DownloadTemplatesTooltip;
